export default "__VITE_ASSET__BpejaYUm__"